import { Button, SliderBtn } from "../buttonsLibrary";
import { CommonData } from "../../datastructures/gamestate/gameData";

import {
  replayCheck,
  jsonCopy,
  displayeGambleGame,
  doubleScaleOnPortrait,
} from "../../functions/Functions_General";
import {
  recoverGameBar,
  recoverStake,
} from "../../functions/Functions_GameBar";
import { startJackpot } from "../../JackpotGame/jackpotGlobalFunctions";
import { GameRoundMetaData, GameRound } from "../APIModels/models";
import { getParameterByName } from "../../getParameters";
import { getAllFakeGameRounds, getFalseRoundDate } from "./fakeGameRounds";
// import { data } from "jquery";
// import { PopupMessageBox } from "../../messageBox";
// import Axios from "axios";

export class Replay {
  private parent: PIXI.Container;
  private ReplayMenuContainer: PIXI.Container;
  private btn_Next: Button;
  private btn_Previous: Button;
  private currrentIndex: number; //index  inside the game rounditself
  private btn_NextRound: Button;
  private activeGameData: CommonData;
  private currentRoundData: GameRound;
  // private nextRoundID: number;
  // private previousRoundID: number;
  private currentRoundID: number;
  private closeBtn: Button;
  private clickable: boolean;
  private skipped: boolean;
  private waterMdark: PIXI.Text;
  private gameRoundDisplay: PIXI.Text;
  private gameRoundTotal: PIXI.Text;
  private gameRoundTotalSub: PIXI.Text;
  private gameRoundDate: PIXI.Text;
  private buttonsContainer: PIXI.Container;
  private startOfNewRound: boolean;

  private open: boolean;
  private bgBOX: PIXI.Graphics;
  private slider: SliderBtn;
  private copyOfReplaysIDandDate: Array<GameRoundMetaData>;

  private idArray: Array<number>;
  private roundIndex: number; //index of  all the gamerounds
  private animateReels: boolean;
  private replayMessageIndex: number;
  private playBtnSprite: PIXI.Sprite;

  private isMobile: boolean;
  private testFakeData: boolean = false; //------<
  constructor(root: PIXI.Container, activeGameData: CommonData) {
    if (window.location.host != "localhost:8080") {
      this.testFakeData = false;
    }
    this.activeGameData = activeGameData;
    this.replayMessageIndex = -1; //
    this.animateReels = false;
    this.open = false;
    this.startOfNewRound = true;
    this.isMobile = getParameterByName("mobile") == "true";

    let textureBTN = new PIXI.Sprite(
      PIXI.Texture.fromImage("replayBtn_next.png")
    );
    this.playBtnSprite = new PIXI.Sprite(
      PIXI.Texture.fromImage("replayBtn_play.png")
    );
    let textureBTN3 = new PIXI.Sprite(
      PIXI.Texture.fromImage("replayBtn_next.png")
    );
    let textureClose = new PIXI.Sprite(
      PIXI.Texture.fromImage("replayBtn_close.png")
    );
    this.parent = new PIXI.Container();

    // if()
    root.addChild(this.parent);
    this.ReplayMenuContainer = new PIXI.Container();
    this.parent.addChild(this.ReplayMenuContainer);

    this.bgBOX = new PIXI.Graphics();
    this.bgBOX.lineStyle(2, 0xffffff, 1);
    this.bgBOX.beginFill(0x000000, 0.6);
    this.bgBOX.drawRoundedRect(-300, -75, 600, 200, 5);

    this.bgBOX.endFill();
    this.ReplayMenuContainer.addChild(this.bgBOX);
    this.bgBOX.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] - 250
    );

    this.bgBOX.interactive = false;
    this.bgBOX.on(
      "pointertap",
      function() {
        // e.preventDefault();
        return false;
      }.bind(this)
    );

    this.buttonsContainer = new PIXI.Container();
    this.bgBOX.addChild(this.buttonsContainer);

    // let hitAreaSize = 55 / 2;
    let hitArea = new PIXI.Rectangle(-40, -40, 80, 80);
    this.btn_Previous = new Button(textureBTN, hitArea);
    textureBTN.rotation = Math.PI;
    this.btn_Next = new Button(this.playBtnSprite, hitArea);
    this.btn_NextRound = new Button(textureBTN3, hitArea);

    this.closeBtn = new Button(textureClose, hitArea);

    this.slider = new SliderBtn(this.bgBOX, this.bgBOX.width - 20);

    this.slider.setPosition([0, 80]);

    this.slider.setNewPosSliderXFromPercentage(100); //

    this.buttonsContainer.addChild(this.btn_Previous.getImage());
    this.buttonsContainer.addChild(this.btn_Next.getImage());
    this.buttonsContainer.addChild(this.btn_NextRound.getImage());
    // this.closeBtn
    this.buttonsContainer.addChild(this.closeBtn.getImage());
    let offset = 100;

    this.closeBtn.setPosition([580, -70]);
    this.btn_Previous.setPosition([50, 25]);
    this.btn_Next.setPosition([50 + offset * 1, 25]);
    this.btn_NextRound.setPosition([50 + offset * 2, 25]);

    // this.buttonsContainer.position.set(this.bgBOX.x, this.bgBOX.y)
    // this.parent.scale.set(.233);
    this.btn_Previous.setFunction(this.setReplay.bind(this, 0));
    this.btn_Next.setFunction(this.setReplay.bind(this, 1));
    this.btn_NextRound.setFunction(this.setReplay.bind(this, 2));
    this.closeBtn.setFunction(this.replayOpenClose.bind(this, 4));

    this.currrentIndex = 0;

    this.currentRoundID = 0;

    this.currentRoundData = null;
    this.clickable = true;
    const waterMarktext =
      this.activeGameData?.gameTextGeneral?.REPLAY ?? "REPLAY";
    this.waterMdark = new PIXI.Text(waterMarktext, {
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontWeight: "bold",
      fontSize: 150,
      fill: "white",
      stroke: "#444444",
      strokeThickness: 30,
    });
    this.waterMdark.anchor.set(0.5);
    this.waterMdark.position.set(
      this.activeGameData.size[0] / 2,
      this.activeGameData.size[1] / 2
    );
    this.waterMdark.alpha = 0;
    this.parent.addChild(this.waterMdark);

    this.gameRoundDisplay = new PIXI.Text(this.currentRoundID.toString(), {
      fontFamily: activeGameData.gameTextStyle.gameFont,

      fontSize: 25,
      fill: "white",
      stroke: "#444444",
      strokeThickness: 3,
    });

    this.gameRoundDate = new PIXI.Text("00/00/0000 00:00", {
      fontFamily: activeGameData.gameTextStyle.gameFont,

      fontSize: 25,
      fill: "white",
      stroke: "#444444",
      strokeThickness: 3,
    });

    this.gameRoundTotal = new PIXI.Text("000/000", {
      fontFamily: activeGameData.gameTextStyle.gameFont,
      fontWeight: "bold",
      fontSize: 50,
      fill: "white",
      stroke: "#444444",
      strokeThickness: 3,
    });

    this.gameRoundTotalSub = new PIXI.Text("1/1", {
      fontFamily: activeGameData.gameTextStyle.gameFont,

      fontSize: 40,
      fill: "white",
      stroke: "#444444",
      strokeThickness: 3,
    });

    this.gameRoundDisplay.anchor.set(1, 0.5);
    this.gameRoundDate.anchor.set(0, 0.5);
    this.gameRoundTotal.anchor.set(1, 0.5);
    this.gameRoundTotalSub.anchor.set(1, 0.5);
    // this.gameRoundDisplay.position.set(1920 / 2 , 1080 / 2-300);
    this.updategameRoundDisplay();
    // this.gameRoundDisplay.alpha = 1;
    this.buttonsContainer.addChild(this.gameRoundDisplay);

    this.buttonsContainer.addChild(this.gameRoundTotal);
    this.buttonsContainer.addChild(this.gameRoundTotalSub);
    this.buttonsContainer.addChild(this.gameRoundDate);

    this.gameRoundDate.position.set(10, -50);
    this.gameRoundDisplay.position.set(600 - 80, -50);
    this.gameRoundTotal.position.set(600 - 10, 0);
    this.gameRoundTotalSub.position.set(600 - 10, 60);
    this.roundIndex = 0;
    this.enableBtns(false); //false

    this.setNewPosition([-300, 0]);

    this.slider.setOnDragFn(this.updateFromSlider);
    this.slider.setOnDragEndFn(this.updateFromSliderAndDoRequest);

    this.idArray = [];
    this.copyOfReplaysIDandDate = [];

    //allows the  replay slider to scale according to the orientation
    // this.setScaleListener();
  }
  // private setScaleListener()
  // {
  //   window.addEventListener("orientationchange",this.portraitScale, false);
  // 	window.addEventListener("resize", this.portraitScale, false);
  //   this.portraitScale();
  // }

  public enableTestReplayLocally = (bool: boolean): void => {
    if (window.location.host == "localhost:8080") {
      this.testFakeData = bool; //-change here
    } else {
      this.testFakeData = false;
    }
  };

  public onResize = (): void => {
    this.portraitScale();
  };

  private portraitScale = (): void => {
    let screenRatio = window.innerHeight / window.innerWidth;
    let isPortraitMode =
      this.activeGameData.playOnPortrait &&
      window.matchMedia("(orientation: portrait)").matches &&
      this.isMobile &&
      screenRatio >= this.activeGameData.minRatioForPortraitPlay;

    if (isPortraitMode) {
      doubleScaleOnPortrait(
        this.isMobile,
        this.ReplayMenuContainer,
        this.activeGameData.size,
        2
      );
    } else {
      //-for slots games
      this.ReplayMenuContainer.scale.set(1);
      this.ReplayMenuContainer.x = 0;
      this.ReplayMenuContainer.y = 0;

      //--for dice games like stardice etc
      if (
        this.activeGameData.gameType == this.activeGameData.gameTypesList[1]
      ) {
        this.ReplayMenuContainer.scale.set(1);
        this.ReplayMenuContainer.x = -625;
        this.ReplayMenuContainer.y = -600;
      }
      //slightly move the game replay interface so taht the bonus game interafce remain visible
      if (
        this.activeGameData.gameId == 100008 ||
        this.activeGameData.gameId == 100010 ||
        this.activeGameData.gameId == 100011 ||
        this.activeGameData.gameId == 100014 ||
        this.activeGameData.gameId == 100013 ||
        this.activeGameData.gameId == 100017
      ) {
        //---christmasJoy
        this.ReplayMenuContainer.y = -60;
      }
      //-

      // if(this.isMobile && this.activeGameData.gameType==this.activeGameData.gameTypesList[0])
      // {
      //   doubleScaleOnPortrait(
      //     this.isMobile,
      //     this.ReplayMenuContainer,
      //     this.activeGameData.size,
      //     15
      //   );

      //   console.log("SKIP")
      // }
      // console.log("SKIP")
    }

    // this.ReplayMenuContainer.y=500
  };

  private updateFromSlider = (): void => {
    let percent = this.slider.getSliderPos();
    this.roundIndex =
      this.idArray.length -
      Math.floor((percent / 100) * this.idArray.length) -
      1; //invert

    if (this.currentRoundID != this.idArray[this.roundIndex]) {
      this.currentRoundID = this.idArray[this.roundIndex];
      this.updategameRoundDisplay();
      this.updateTotalRounds();
      this.disableNextPrevious();
    }
  };

  private updateFromSliderAndDoRequest = (): void => {
    let percent = this.slider.getSliderPos();
    this.roundIndex =
      this.idArray.length -
      Math.floor((percent / 100) * this.idArray.length) -
      1;
    if (this.roundIndex < 0) {
      this.roundIndex = 0;
    }
    this.defaultClearAndLock();
    // this.currentRoundID = this.idArray[this.roundIndex];
    // this.updategameRoundDisplay();

    // this.updateTotalRounds();
    // this.updatSliderFromIndex();

    this.currentRoundID = this.idArray[this.roundIndex];
    this.updategameRoundDisplay();
    this.updateTotalRounds();
    this.disableNextPrevious();

    this.slider.setButtonMode(false);
    this.requestServer();
    // console.log('success')
  };

  private updategameRoundDisplay = (): void => {
    this.gameRoundDisplay.text =
      (this.activeGameData?.gameTextGeneral?.GAMEROUNDID ?? "Round") +
      ": " +
      this.currentRoundID;

    if (
      this.currentRoundData != null &&
      this.roundIndex >= 0 &&
      this.roundIndex < this.copyOfReplaysIDandDate.length
    ) {
      const startDate = this.copyOfReplaysIDandDate[this.roundIndex]
        ?.startDateTime;
      if (!startDate) return;

      const localTime = new Date(startDate);
      if (isNaN(localTime.getTime())) return;

      const displayTime =
        localTime.toLocaleDateString("en-GB") +
        " " +
        localTime
          .getHours()
          .toString()
          .padStart(2, "0") +
        ":" +
        localTime
          .getMinutes()
          .toString()
          .padStart(2, "0") +
        ":" +
        localTime
          .getSeconds()
          .toString()
          .padStart(2, "0");

      this.gameRoundDate.text = displayTime;
    }
  };

  public setNewPosition = (newPosition: Array<number>): void => {
    this.buttonsContainer.position.set(newPosition[0], newPosition[1]);
  };

  public openReplay = (): void => {
    this.activeGameData.gameOption.setClicked(); //close the gameoptwindow
    this.replayOpenClose();
  };

  // private openReplayMode = (): void => {
  //   this.replayOpenClose();
  // };

  private replayOpenClose = (): void => {
    this.activeGameData.updateBalanceOnRecovery = false;
    if (this.activeGameData.replayMode == true) {
      this.activeGameData.replayMode = false;
      this.bgBOX.interactive = false;
      //--
      console.log("CLOSE REPLAY MODE");
      if (this.activeGameData.jackPotGame.isJackpotOpen()) {
        this.activeGameData.jackPotGame.stop();
      }

      this.parent.alpha = 0;
      this.activeGameData.betResponse = jsonCopy(
        this.activeGameData.cloneBetRepsonse
      );
      // console.log("CLONED AFTER",this.activeGameData.cloneBetRepsonse.gameContext.contextData.gameBoxes[0])
      this.activeGameData.clearOnReplayOpenClose(); //clear default game
      // this.gameRoundDisplay.alpha = 0;
      this.waterMdark.alpha = 0;
      this.currrentIndex = 0;
      this.tintPlay(false);
      this.roundIndex = 0;

      this.slider.setNewPosSliderXFromPercentage(100); //
      // this.activeGameData.replayMode = false;
      this.enableBtns(false); //--disable replay mode btn bc closing replay

      this.activeGameData.reloadGame = true;
      this.idArray = [];
      this.copyOfReplaysIDandDate = [];

      // if(this.activeGameData.bonusGameMode)
      this.currentRoundID = 0;
      this.activeGameData.displayReplayMsg = true;
      this.activeGameData.recoverSuccess(this.activeGameData.betResponse);
      this.activeGameData.updateBalanceOnRecovery = true;

      this.open = false;
      //request new balance
      this.activeGameData.requestNewBalance(this.activeGameData); //UPDATE THE BALANCE
    } else {
      if (
        this.activeGameData.emulationMode &&
        this.activeGameData.emulationMode.getISVisible()
      ) {
        this.activeGameData.emulationMode.closeEmulationMenuExpand();
      }
      console.log("OPEN REPLAY MODE");
      this.activeGameData.replayMode = true;
      this.bgBOX.interactive = true;
      // console.log('openReplay')
      this.open = true;
      this.parent.alpha = 1;
      if (this.activeGameData.InspectReplay == false) {
        this.activeGameData.clearOnReplayOpenClose();
      }

      this.activeGameData.updateBalanceOnRecovery = false;
      this.waterMdark.alpha = 0.45;

      this.enableBtns(true); //enable the replay UI
      this.activeGameData.cloneBetRepsonse = jsonCopy(
        this.activeGameData.betResponse
      ); //--clone the activegame data i

      // console.log("CLONED BEFORE",this.activeGameData.cloneBetRepsonse.gameContext.contextData.gameBoxes[0])
      if (this.testFakeData == false) {
        ////initial replay call asking for all the rounds
        this.activeGameData.API_handler.GetAllReplaysResult(
          this.successGetRound,
          this.failRequest
        );
      } else {
        ///--fake data
        let f = this.falseRoundDate();
        this.successGetRound(f);
      }
    }
  };

  public inspectReplayGotoSelectedGameRound = (): void => {
    if (this.activeGameData.InspectReplay) {
      let GameRoundToPlay = parseInt(getParameterByName("replayGameRoundId"));
      this.roundIndex = this.idArray.indexOf(GameRoundToPlay);
      if (this.roundIndex == -1) {
        this.roundIndex = 0;
      } //if it dont  exist then play the last
    }
  };

  private enableBtns = (bool: boolean): void => {
    //   console.log(bool)
    if (bool) {
      replayCheck(this.activeGameData); //disable the game ui like option windows etc
      if (this.activeGameData.gambleGame != undefined) {
        displayeGambleGame(false, this.activeGameData);
      }
      this.parent.alpha = 1;
      this.slider.setButtonMode(bool);
    } else {
      this.parent.alpha = 0;

      this.slider.setButtonMode(bool);
    }
    // console.log("enable btns", bool)
    this.btn_NextRound.setInteractive(bool);
    this.btn_Next.setInteractive(bool);
    this.btn_Previous.setInteractive(bool);

    let alphaa = bool ? 1 : 0;
    this.btn_Next.setAlpha(alphaa);
    this.btn_NextRound.setAlpha(alphaa);
    this.btn_Previous.setAlpha(alphaa);

    if (this.activeGameData.InspectReplay == false) {
      this.closeBtn.setInteractive(bool);
      if (bool) {
        this.closeBtn.setNewTexture(
          PIXI.Texture.fromImage("replayBtn_close.png")
        );
        //newUpdate
        this.closeBtn.setAlpha(1);
      } else {
        this.closeBtn.setNewTexture(
          PIXI.Texture.fromImage("replayBtn_open.png")
        );
        //newUpdate
        this.closeBtn.setAlpha(0);
      }
    } else {
      this.closeBtn.setInteractive(false);
      this.closeBtn.setAlpha(0);
    }
  };

  private disableNextPrevious() {
    if (this.roundIndex == 0) {
      this.btn_NextRound.setInteractive(false);
      this.btn_NextRound.setAlpha(0.5);
    } else {
      this.btn_NextRound.setInteractive(true);
      this.btn_NextRound.setAlpha(1);
    }

    if (this.roundIndex == this.idArray.length - 1) {
      this.btn_Previous.setInteractive(false);
      this.btn_Previous.setAlpha(0.5);
    } else {
      this.btn_Previous.setInteractive(true);
      this.btn_Previous.setAlpha(1);
    }

    this.checkNextBtnInteractivity();
  }

  private checkNextBtnInteractivity = (): void => {
    //--disable play on last

    if (
      this.roundIndex == 0 &&
      this.currrentIndex >= this.currentRoundData.gameContexts.length
    ) {
      this.btn_Next.setInteractive(false);
      this.btn_Next.setAlpha(0.5);

      if (this.currentRoundData.gameContexts.length == 1) {
        // console.log(this.currentRoundData.gameContexts.length )
        this.btn_Next.setInteractive(true);
        this.btn_Next.setAlpha(1);
      }
    } else {
      this.btn_Next.setInteractive(true);
      this.btn_Next.setAlpha(1);
    }
  };

  private defaultClearAndLock = (): void => {
    this.clickable = false;
    this.skipped = false;
    //-- for slot games clear winlines etc
    if (this.activeGameData.gameType == this.activeGameData.gameTypesList[0]) {
      this.activeGameData.mainGame.setWinlineHidden(); //hide winlines;
      this.activeGameData.gameBar.setGambleButtonActive(false); //hide gamble btn
      this.activeGameData.winAnimation.stop();
    }
  };

  private tintPlay = (boo: boolean): void => {
    if (boo) {
      this.playBtnSprite.tint = 0xaaffaa;
    } else {
      this.playBtnSprite.tint = 0xffffff;
    }
  };

  public replayGoToNextStep = (): void => {
    this.setReplay(1);
  };
  public getNewStepData = (): void => {
    if (this.currrentIndex < this.currentRoundData.gameContexts.length) {
      this.activeGameData.betResponse.gameContext = this.currentRoundData.gameContexts[
        this.currrentIndex
      ];
    } else {
      console.error("currrentIndex out of range");
    }
  };

  private setReplay = (indexBtn: number): void => {
    // close the jackpot
    if (this.activeGameData.jackPotGame.isJackpotOpen()) {
      this.activeGameData.jackPotGame.stop();
    }

    this.activeGameData.replayMode = true;

    if (this.clickable) {
      this.defaultClearAndLock();
      //   console.log(indexBtn)
      switch (indexBtn) {
        case 0:
          // go to previous round
          // console.log(this.roundIndex ,"/", this.idArray.length- 1)
          if (this.roundIndex == this.idArray.length - 2) {
            this.animateReels = true;
          } else {
            this.animateReels = false;
          }
          this.animateReels = false;
          this.goPreviousRound();
          break;
        case 1:
          //load new step or go to next round
          // console.log('CLICk',  this.currrentIndex >
          // this.currentRoundData.gameContexts.length - 1)
          this.animateReels = true;
          // console.log("clicked replay btn ", this.currentRoundData)
          if (this.currentRoundData == null) {
            // console.log('CLICssk')
            this.goNextRound();
          } else if (
            this.currrentIndex >
            this.currentRoundData.gameContexts.length - 1
          ) {
            // console.log('ss',this.roundIndex, this.copyOfReplaysIDandDate.length)

            if (
              this.idArray.length == 1 &&
              this.currrentIndex >= this.currentRoundData.gameContexts.length
            ) {
              this.currrentIndex = 0;
              this.tintPlay(false);
              this.goNextStep();
            } else {
              //--
              // console.log("gotonewround")
              this.goNextRound();
            }
            // this.goNextRound();
          } else {
            // console.log(this.roundIndex, this.copyOfReplaysIDandDate.length)

            this.goNextStep();
          }
          break;

        case 2:
          //-go to Next round
          this.animateReels = false;
          this.goNextRound();

          break;

        default:
          break;
      }
    } else if (this.skipped == false) {
      this.skipped = true;
      this.activeGameData.skipGame();
    }
  };

  public setClickable = (bool: boolean): void => {
    // console.log("is replay clickable",bool)
    this.clickable = bool;
    this.slider.setButtonMode(bool);
  };
  public getCurrentIndex = (): number => {
    return this.currrentIndex;
  };
  private goNextRound = (): void => {
    // console.log("-----------------------------------GO TO NEW GAME ROUND");

    this.currrentIndex = 0;
    this.tintPlay(false);
    if (this.roundIndex > 0) {
      this.roundIndex--;
      // console.log('--newRound',this.currentRoundID, this.idArray[this.roundIndex])
      this.currentRoundID = this.idArray[this.roundIndex];

      this.updategameRoundDisplay();
      this.requestServer();
    } else {
      this.endOfGameRoundsCheck();
    }
  };

  private endOfGameRoundsCheck = (): void => {
    if (this.roundIndex <= 0) {
      if (this?.currrentIndex >= this.currentRoundData?.gameContexts?.length) {
        //cant play
        // console.log('--newRoundIndex',this.roundIndex,'END OF SPINS PLAY' );
        this.reachedEndOfSpins();
      }
    }
  };
  private reachedEndOfSpins = (): void => {
    this.setClickable(true);
    this.btn_Next.setInteractive(false);
    this.btn_Next.setAlpha(0.5);
  };

  public getAllRounds = (): any => {
    return this.currentRoundData.gameContexts;
  };
  public getRoundContextData = (): any => {
    this.activeGameData.betResponse.gameContext = this.currentRoundData.gameContexts[
      this.currrentIndex
    ];
    return this.currentRoundData.gameContexts[this.currrentIndex];
  };

  public getRoundBetResponseData = (): any => {
    this.activeGameData.betResponse.gameContext = this.currentRoundData.gameContexts[
      this.currrentIndex
    ];
    return this.activeGameData.betResponse;
  };
  private goNextStep = (): void => {
    this.updateSubText();
    //  console.log("goNextStep")
    // console.log(this.activeGameData.betResponse.gameContext.contextData)
    this.setClickable(false);
    if (this.animateReels) {
      this.startOfNewRound = false;
      // this.setClickable(false);
      this.activeGameData.betResponse.gameContext = this.currentRoundData.gameContexts[
        this.currrentIndex
      ];

      this.activeGameData.replayFn(); //call the game replay function
      if (this.activeGameData.isTableGame === false) {
        recoverGameBar(this.activeGameData); //update the game bet amount
      }

      this.animateReels = false;
      this.checkNextBtnInteractivity();

      // console.log(this.currrentIndex);
    } else {
      //--//while skipping  through games
      // console.log("goToNewRoundSkipAnimations");

      this.startOfNewRound = false;
      this.activeGameData.clearOnReplayOpenClose();
      this.currrentIndex = 0;
      this.tintPlay(false);
      this.activeGameData.betResponse.gameContext = this.currentRoundData.gameContexts[
        this.currrentIndex
      ];
      this.activeGameData.reloadGame = true;
      this.activeGameData.displayReplayMsg = false;
      //-game where just play the spin instead of calling recovery
      if (this.activeGameData.useSpinOnReplayInsteadOfRecovery) {
        //play the start spin
        this.activeGameData.replayFn(); //call the game replay function
      } else {
        //default jump to result
        this.activeGameData.recoverSuccess(this.activeGameData.betResponse);
      }
      this.setClickable(true);
      // this.clickable = true;

      // console.log("load new CONTEXT",this.activeGameData.betResponse.gameContext);
    }
  };
  //-!important/-------------------------------------------------------------------------------------------------------------------
  //-!important/-------------------------------------------------------------------------------------------------------------------
  //-!important/-------------------------------------------------------------------------------------------------------------------
  //-!important/-------------------------------------------------------------------------------------------------------------------

  public replayStakeUseCheck = (): void => {
    if (this.activeGameData.replayMode) {
      //substract stake
      //-
      let activeStake = this.currentRoundData.gameContexts[this.currrentIndex]
        .contextData.stake.amount;
      let endPlayerBalance =
        this.currentRoundData.startPlayerBalance.creditsBalance.amount -
        activeStake;

      let isBonusBought: string = this.activeGameData.betResponse.gameContext
        .contextData.bonusTriggerType;
      if (isBonusBought != undefined && isBonusBought === "BOUGHT") {
        if (this.activeGameData.loginResponse.gameSettings.buyBonusEnabled) {
          endPlayerBalance =
            this.currentRoundData.startPlayerBalance.creditsBalance.amount -
            activeStake *
              this.activeGameData.loginResponse.gameSettings.buyBonusFactor;
        }
      }
      // this.activeGameData.betSelected.getServerVal());

      this.activeGameData.balance.updateValue(endPlayerBalance);
      this.activeGameData.gameBar.setBalValue(
        this.activeGameData.balance.getDisplayValue()
      );
    }
  };

  public replayCollectWinCheck = (): void => {
    if (this.activeGameData.replayMode) {
      if (
        this.currentRoundData.gameContexts[this.currrentIndex].contextData
          .finished
      ) {
        //-if
        let collectWinValue = this.currentRoundData.gameContexts[
          this.currrentIndex
        ].contextData.win.credits.amount;

        let activeStake = this.currentRoundData.gameContexts[this.currrentIndex]
          .contextData.stake.amount;
        let endPlayerBalance =
          collectWinValue +
          this.currentRoundData.startPlayerBalance.creditsBalance.amount -
          activeStake;
        // console.log("tolal bal after collect :", endPlayerBalance);
        this.activeGameData.balance.updateValue(endPlayerBalance);
        this.activeGameData.gameBar.setBalValue(
          this.activeGameData.balance.getDisplayValue()
        );

        // //----clear win

        this.activeGameData.winValue.updateValue(0); //( activeGameData.winValue=((activeGameData.betResponse.balance)).credits.amount);
        this.activeGameData.gameBar.setWinValue(
          this.activeGameData.winValue.getDisplayValue()
        );

        if (
          this.activeGameData.betResponse.gameContext.contextData.win !=
          undefined
        ) {
          this.activeGameData.betResponse.gameContext.contextData.win.credits.amount = 0;
        }
        if (
          this.activeGameData.betResponse.gameContext.contextData
            .bonusSpinWin != undefined
        ) {
          this.activeGameData.betResponse.gameContext.contextData.bonusSpinWin.credits.amount = 0;
        }
      }
    }
  };

  public resetIndex = (): void => {
    // console.log(this.currrentIndex,"/", this.currentRoundData.gameContexts.length);
    this.currrentIndex = 0;
  };

  private updateSubText = (): void => {
    let currentSubIndex = this.currrentIndex > 0 ? this.currrentIndex : 1;
    let currentSubTotal =
      this.currentRoundData?.gameContexts?.length > 0
        ? this.currentRoundData?.gameContexts?.length
        : 1;
    this.gameRoundTotalSub.text = currentSubIndex + "/" + currentSubTotal;
  };

  public incrementIndex = (): void => {
    if (this.currentRoundData?.gameContexts?.length != undefined) {
      this.currrentIndex++;
      this.updateSubText();

      console.log(
        "currentGameRound:" + this.currrentIndex,
        "/",
        this.currentRoundData?.gameContexts?.length
      );

      this.endOfGameRoundsCheck();
    }
  };

  public setIndexToLast = (): void => {
    this.currrentIndex = this.currentRoundData.gameContexts.length - 2;
  };

  public replayindexIncrement = (): void => {
    //used for breaking symbols games
    if (this.currrentIndex < this.currentRoundData.gameContexts.length - 1) {
      this.currrentIndex++;
    } else {
      // console.log("RESET INCEX",this.currrentIndex)
      this.currrentIndex = 1;
    }
    console.log(
      "currentGameRound:",
      this.currrentIndex + "/" + this.currentRoundData.gameContexts.length
    );
    //update the subtext
    let currentSubIndex = this.currrentIndex > 0 ? this.currrentIndex : 1;
    let currentSubTotal =
      this.currentRoundData?.gameContexts?.length > 0
        ? this.currentRoundData?.gameContexts?.length
        : 1;
    this.gameRoundTotalSub.text = currentSubIndex + "/" + currentSubTotal;
  };

  private goToInitialRound = (): void => {
    //-start loading the first gameplay round on replay when replay opens
    if (this.activeGameData.jackPotGame.isJackpotOpen()) {
      this.activeGameData.jackPotGame.stop();
    }
    this.inspectReplayGotoSelectedGameRound();
    this.activeGameData.replayMode = true;
    if (this.roundIndex < this.idArray.length && this.roundIndex > -1) {
      this.currentRoundID = this.idArray[this.roundIndex];
      this.updategameRoundDisplay();
      this.requestServer();
    }
  };

  private goPreviousRound = (): void => {
    this.currrentIndex = 0;
    // console.log("-----------------------------------GO TO NEW GAME ROUND BACK");
    // console.log(this.currrentIndex,"/", this.currentRoundData.gameContexts.length);

    if (this.roundIndex < this.idArray.length - 1) {
      this.roundIndex++;
      this.currentRoundID = this.idArray[this.roundIndex];
      this.updategameRoundDisplay();
      this.requestServer();
    }

    // console.log(this.roundIndex)
  };

  private requestServer() {
    this.startOfNewRound = true;
    this.activeGameData.API_handler.setactiveRoundID(this.currentRoundID);
    this.currrentIndex = 0;
    this.tintPlay(false);
    if (this.testFakeData == false) {
      //---do request to server
      this.activeGameData.API_handler.GetReplayResult(
        this.success,
        this.failRequest
      );
    } else {
      let f = this.falseRounds(this.roundIndex);
      this.success(f);
    }
  }

  private updateRoundBal = (): void => {
    this.activeGameData.balance.updateValue(
      this.currentRoundData.startPlayerBalance.creditsBalance.amount
    );

    this.activeGameData.gameBar.setBalValue(
      this.activeGameData.balance.getDisplayValue()
    );
  };

  private updatSliderFromIndex = (): void => {
    let current = this.idArray.indexOf(this.currentRoundID);
    let valInPercent =
      100 - (100 / (this.copyOfReplaysIDandDate.length - 1)) * current;
    this.slider.setNewPosSliderXFromPercentage(valInPercent); //invert
  };
  private updateTotalRounds = (): void => {
    let current = this.idArray.indexOf(this.currentRoundID);

    this.gameRoundTotal.text =
      this.copyOfReplaysIDandDate.length -
      current +
      "/" +
      this.copyOfReplaysIDandDate.length;
  };
  private successGetRound = (data: any): void => {
    this.copyOfReplaysIDandDate = jsonCopy(data);
    if (this.copyOfReplaysIDandDate.length > 0) {
      for (let i = 0; i < this.copyOfReplaysIDandDate.length; i++) {
        this.idArray[i] = this.copyOfReplaysIDandDate[i].id;
      }
      this.gameRoundTotal.text = 0 + "/" + this.copyOfReplaysIDandDate.length;

      this.currentRoundID = data[0].id;
      this.currentRoundData = data[0];
      this.updategameRoundDisplay();
      this.goToInitialRound();

      this.replayMessageIndex = 1;
    } else {
      //no replay available
      this.activeGameData.replayMode = true; //will be set to false on check  on replayOpenClose
      this.replayMessageIndex = 0;
      this.replayOpenClose();
    }
  };

  public getMessageToDisplay = (): string => {
    switch (this.replayMessageIndex) {
      case 0:
        return this.activeGameData.gameTextGeneral.NoReplayFound;
        break;
      case 1:
        return this.activeGameData.gameTextGeneral.BackToGame;
        break;

      default:
        break;
    }
  };

  public updateJackpot() {
    // startJackpot
    // return
    if (this.currentRoundData.hasOwnProperty("jackpotContext")) {
      this.activeGameData.jackpotContext = this.currentRoundData.jackpotContext;
      startJackpot(this.activeGameData);
    } else {
      this.activeGameData.jackpotContext = null;
    }
  }

  private updateBet() {
    if (this.activeGameData.isTableGame === false) {
      recoverStake(
        this.activeGameData.betResponse.gameContext.contextData.stake.amount,
        this.activeGameData
      );
    }
    // console
  }

  private success = (data: any): void => {
    this.currentRoundData = data;
    this.updateRoundBal();
    this.updateTotalRounds();
    this.updatSliderFromIndex();
    this.getRoundContextData();
    this.updateBet();
    this.disableNextPrevious();

    this.goNextStep();

    this.updateJackpot();
  };

  public failRequest = (errorType: string): void => {
    this.activeGameData.errorTypeToDisplay = errorType;
    this.activeGameData.callBackFailMessage(6);
    this.activeGameData.disableAllBtns(this.activeGameData);
  };

  public getIsNewRound = (): boolean => {
    return this.startOfNewRound;
  };

  public disable = (bool: boolean): void => {
    if (this.open) {
      this.clickable = !bool;
    }

    if (this.activeGameData.InspectReplay == false) {
      this.closeBtn.setInteractive(!bool);
    } else {
      this.closeBtn.setInteractive(false);
    }

    // console.log("DISABLE REPLAY")?
  };
  public isTestMode = (): boolean => {
    return this.testFakeData;
  };
  public isOpen = (): boolean => {
    return this.open;
  };

  ///TEST DATA
  falseRoundDate() {
    return getFalseRoundDate();
  }

  falseRounds(i: number) {
    let all: any = getAllFakeGameRounds();

    return all[i];
  }
}
